import { render, staticRenderFns } from "./SidebarFormRow.vue?vue&type=template&id=27aa2a32&scoped=true&"
import script from "./SidebarFormRow.vue?vue&type=script&lang=js&"
export * from "./SidebarFormRow.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFormRow.vue?vue&type=style&index=0&id=27aa2a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa2a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
